/* src/app/components/ortho/acreditacion-registro/acreditacion-registro.component.scss */
/*# sourceMappingURL=acreditacion-registro.component.css.map */
